/**
 * The assistant opens from the top bar's sparkle button (it used to float over the screen, where it covered order
 * totals and actions mid-scroll). The panel and the button live in different parts of the shell, so they talk through
 * one window event instead of lifting the panel's state into the shell.
 */
export const ASSISTANT_OPEN_EVENT = 'souk:assistant-open';

export function openAssistant(): void {
  window.dispatchEvent(new Event(ASSISTANT_OPEN_EVENT));
}
